'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaStumbleuponCircle = function FaStumbleuponCircle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm22.3 18.7l2-0.6v-1.4q0-1.7-1.3-3t-3-1.2-3.1 1.2-1.3 3v6.3q0 0.5-0.3 0.8t-0.8 0.3-0.7-0.3-0.3-0.8v-2.6h-3.4v2.7q0 1.8 1.3 3.1t3.1 1.3q1.8 0 3.1-1.3t1.3-3.1v-6.2q0-0.4 0.3-0.7t0.8-0.4q0.4 0 0.7 0.4t0.3 0.7v1.2z m7.5 4.4v-2.7h-3.4v2.8q0 0.4-0.3 0.7t-0.7 0.3q-0.5 0-0.8-0.3t-0.3-0.7v-2.8l-2 0.6-1.3-0.6v2.7q0 1.8 1.3 3.1t3.1 1.3 3.1-1.3 1.3-3.1z m7.5-3.1q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
        )
    );
};

exports.default = FaStumbleuponCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/stumbleupon-circle.js
// module id = 1051
// module chunks = 168707334958949